import { BookingDataForm, BookingWorkflowData } from '../model/booking.model';
import {
  MOCK_BOOKING_CARTRIDGE_DATA,
  MOCK_BOOKING_CARTRIDGE_VARIANT_DATA,
  MOCK_BOOKING_ORGANIZATION_DETAILS_DATA,
  MOCK_BOOKING_USER_DATA,
} from '@markant-platform/cartridge/util-testing';
import { BookingPriceRequest } from '@markant-platform/cartridge/model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegexPattern } from '@markant-platform/shared/util-helpers';
import { OrganizationType } from 'data-model';

export const MOCK_BOOKING_WORKFLOW_DATA: BookingWorkflowData = {
  cartridge: MOCK_BOOKING_CARTRIDGE_DATA,
  variant: MOCK_BOOKING_CARTRIDGE_VARIANT_DATA,
  organization: MOCK_BOOKING_ORGANIZATION_DETAILS_DATA,
  user: MOCK_BOOKING_USER_DATA,
  serviceGtcAccepted: false,
};

export const MOCK_BOOKING_PRICE_REQUEST: BookingPriceRequest = {
  id: '7',
  offerPrice: {
    currency: 'EUR',
    centAmount: 12345,
    priceModel: 'SUBSCRIPTION',
    billingPeriod: 'MONTHLY',
    targetAudience: {
      organizationType: OrganizationType.DEALER,
      ezr: false,
    },
    hasToBeRequested: true,
  },
  variantId: MOCK_BOOKING_CARTRIDGE_VARIANT_DATA.variantId,
  cartridgeId: MOCK_BOOKING_CARTRIDGE_DATA.id,
  offerNumber: '12',
};
export const MOCK_BOOKING_WORKFLOW_DATA_WITH_PRICE_REQUEST: BookingWorkflowData = {
  ...MOCK_BOOKING_WORKFLOW_DATA,
  priceRequest: MOCK_BOOKING_PRICE_REQUEST,
};

export const MOCK_BOOKING_DATA_FORM: () => BookingDataForm = () => {
  return new FormGroup({
    billingEmail: new FormControl('', [
      Validators.required,
      Validators.pattern(RegexPattern.BILLING_EMAIL_PATTERN),
      Validators.pattern(RegexPattern.XSS_PATTERN),
    ]),
    billingLanguageIsoCode: new FormControl('', Validators.required),
    references: new FormGroup({
      customerCartridgeReferenceId: new FormControl(''),
      costCenter: new FormControl(''),
      otherReferences: new FormControl(''),
    }),
  });
};
